import { Component, OnInit } from '@angular/core';
import { ColDef, RowNode } from 'ag-grid-community';

export interface OnRowGroupToggledParams {
    rowGroupToFilter: string;
    collapsed: boolean;
}

export interface GetIconClassCallbackParams {
    columnType: string;
    rowData: any;
    isCollapsed: boolean;
    isInARowGroupHeaderRow: boolean;
    isARowGroupHeaderCell: boolean;
}

@Component({
    selector: 'app-cell-renderer',
    templateUrl: './cell-renderer.component.html',
    styleUrls: ['./cell-renderer.component.scss']
})
export class CellRendererComponent implements OnInit {

    constructor() { }

    public value: string;
    public iconClass: string;
    public isInANestedRow = false;
    private colDef: ColDef;
    private field: string;
    private rowData: any;
    private params: any;
    private headerName: string;
    private isInARowGroupHeaderRow: boolean;
    private isARowGroupHeaderCell: boolean;
    private iconCallback: Function;
    private rowGroupToggledCallback: Function;
    private isRowGroupHeaderCallback: Function;
    private rowGroupHeaderColumn: any;
    private rendererParams: any;
    private isCollapsed = false;

    ngOnInit() {
    }

    agInit(params: any): void {
        this.params = params;
        this.rowData = params.data;
        this.value = params.value || 'n/a';
        this.colDef = params.column.colDef;
        this.field = this.colDef.field;
        this.headerName = this.colDef.headerName;
        this.rendererParams = this.colDef.cellRendererParams;

        this.iconCallback = this.rendererParams.getIconCallback;
        this.isRowGroupHeaderCallback = this.rendererParams.isRowGroupHeaderCallback;
        this.rowGroupHeaderColumn = this.rendererParams.rowGroupHeaderColumn;
        this.rowGroupToggledCallback = this.rendererParams.rowGroupToggledCallback;

        if (this.isRowGroupHeaderCallback) {
            this.isInANestedRow = this.isANestedRow();
            this.isInARowGroupHeaderRow = !this.isInANestedRow;
            this.isARowGroupHeaderCell = this.isInARowGroupHeaderRow && this.field === this.rowGroupHeaderColumn;
        }

        if (this.iconCallback) {
            this.iconClass = this.iconCallback({
                isCollapsed: this.isCollapsed,
                columnType: this.headerName,
                rowData: this.rowData,
                isInARowGroupHeaderRow: this.isInARowGroupHeaderRow,
                isARowGroupHeaderCell: this.isARowGroupHeaderCell
            } as GetIconClassCallbackParams);
        }
    }

    public isNotApplicable(): boolean {
        return this.value === 'n/a';
    }

    public onClick($event) {
        this.isCollapsed = !this.isCollapsed;

        if (this.rowGroupToggledCallback) {
            this.rowGroupToggledCallback({
                rowGroupToFilter: this.rowData[this.rowGroupHeaderColumn],
                collapsed: this.isCollapsed
            } as OnRowGroupToggledParams);
        }

        if (this.iconCallback) {
            this.iconClass = this.iconCallback({
                columnType: this.headerName,
                rowData: this.rowData,
                isCollapsed: this.isCollapsed,
                isInARowGroupHeaderRow: this.isInARowGroupHeaderRow,
                isARowGroupHeaderCell: this.isARowGroupHeaderCell
            } as GetIconClassCallbackParams);
        }
    }

    private isANestedRow() {
        if (this.isRowGroupHeaderCallback && this.isRowGroupHeaderCallback({ data: this.rowData } as RowNode)) {
            return false;
        } else {
            return true;
        }
    }
}
